import html2canvas from 'html2canvas';
import { useState } from 'react'
import { createPortal } from 'react-dom';


const ModalPortal = ({ children }) => {
  const target = document.querySelector(".container.start");
  return createPortal(children, target);
};

const useModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  // const [image, setImage] = useState(JSON.parse(localStorage.getItem("image"))  ||  [] )
  const [image, setImage] = useState([]);
  const saveAsImage = (uri) => {
    const downloadLink = document.createElement("a");

    if(typeof downloadLink.download === "string"){
      downloadLink.href = uri;

      // ファイル名
      downloadLink.download = "avatar.png";
       // Firefox では body の中にダウンロードリンクがないといけないので一時的に追加
      document.body.appendChild(downloadLink);
      // ダウンロードリンクが設定された a タグをクリック
      downloadLink.click();
      // Firefox 対策で追加したリンクを削除しておく
      document.body.removeChild(downloadLink);
    } else {
      window.open(uri);
    }
  }

  const onClickExport = () => {
    // 画像に変換する component の id を指定
    const target = document.getElementById("target-component");

    target.style.width = '250px';
    target.style.height = '250px';
    target.style.borderRadius = '0px';
    html2canvas(target).then(canvas => {
      const targetImgUri = canvas.toDataURL("img/png");
      setImage(targetImgUri);
      target.style.width = '';
      target.style.height = '';
      target.style.borderRadius = '10px';
    }).then(()=> setModalOpen(true))
  }


  const handleSaveClick = () => {
    saveAsImage(image);
  }

  return {ModalPortal, onClickExport, handleSaveClick, modalOpen, setModalOpen, image}
}

export default useModal
